import Vue from 'vue';
import * as http from 'axios';
import store from '../store';
import router from '../router';

let timeout = null;
let config = {
  baseURL: process.env.VUE_APP_BASE_URL ?? '//api.local/',
  headers: { 'Device-Type': 0 }
};

const axios = http.create(config);
axios.defaults.headers.common['Accept-Language'] = localStorage.getItem('LANG');
axios.interceptors.request.use(
  config => {
    if (store.getters['Auth/isAuthenticated']) {
      config.headers.Authorization = `Bearer ${store.getters['Auth/token']}`;
    }

    if (timeout) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        console.info('LOADING NUNGGU');
      }, 8000);
    }

    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(undefined, error => {
  const errorResponse = error?.response;
  const originalRequest = error?.config;

  if (
    errorResponse?.config.url !== 'api/user/validate-email' &&
    !Object.prototype.hasOwnProperty.call(errorResponse?.data, 'disableNotification') &&
    !http.isCancel(error)
  ) {
    store.dispatch('general/showErrorReqNotification', error);
  }

  if (errorResponse?.status === 401 && originalRequest.url === 'api/auth/refresh') {
    router.push({ name: 'AuthLogin', replace: true });
    return Promise.reject(error);
  }

  if (errorResponse?.status === 401 && !originalRequest._retry && originalRequest.url !== 'api/auth/verify-delete-account') {
    originalRequest._retry = true;
    store
      .dispatch('Auth/refresh')
      .then(({ token }) => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios(originalRequest);
      })
      .catch(() => {
        store.dispatch('Auth/clearSession');
        router.push({ name: 'AuthLogin' }).catch();
        return Promise.reject();
      });
  }

  // Server Maintenance
  else if (errorResponse?.status === 502) {
    router.push({ name: 'ServerMaintenance', replace: true });
  }
  // Server Busy
  else if (errorResponse?.status === 503) {
    router.push({ name: 'ServerBusy', replace: true });
  }

  return Promise.reject(error);
});

Plugin.install = function(Vue) {
  Vue.axios = axios;
  window.axios = axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return axios;
      }
    },
    $axios: {
      get() {
        return axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
